import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { StaffService } from '../../services/staff/staff.service';
import { ClientService } from '../../services/client.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FolderService } from 'src/app/services/folder.service';
import { FilterService } from 'src/app/services/filter.service';
import { AssetService } from '../../services/asset.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-share-file-modal',
  templateUrl: './share-file-modal.component.html',
  styleUrls: ['./share-file-modal.component.scss']
})
export class ShareFileModalComponent implements OnInit {
  @Input('details') recievedFile;
  // @Output() assetUser: EventEmitter<any> = new EventEmitter<any>();
  isPresent: any;
  isPresentClient: boolean;
  copyInstructors: any;
  copyClients: any;
  afterFilter: string;
  buttonLoader: boolean = false;
  assetallocationList
  constructor(public _staffService: StaffService,
    public _clientService: ClientService,
    public _folderService: FolderService,
    public dialogRef: MatDialogRef<ShareFileModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogdata: any,
    public _filter: FilterService,
    public _assetService: AssetService) { }

  instructors;
  clients;
  searchText;
  selectedInstructors = [];
  selectedClients = [];
  selInstructor = [];
  alreadySharedInstructor = [];
  alreadySharedClient = [];
  loading: boolean = false;
  // filter;
  data;
  isAsset
  siteList = []
  siteListCopy = []
  selectedSites = []
  jobList = []
  jobListCopy = []
  selectedJobs = []
  alreadySharedSites = []
  ngOnInit() {
    console.log("DATA IN Share File::::::::: = ", this.dialogdata);
    if (this.dialogdata && this.dialogdata.asset) {
      console.log("this is for asset file sharing ");
      // this.getInstructors();
      // this.getClients();
      this.isAsset = this.dialogdata.asset
      /**=======================instructor list========================================= */

      // if (this.dialogdata.asset && this.dialogdata.instructors) {
      //   this.dialogdata.instructors.forEach((ins) => {
      //     // ins.checked = false;
      //     ins.doHave = false;
      //   })
      //   this.instructors = this.dialogdata.instructors;
      //   this.copyInstructors = this.instructors;
      //   if (this.dialogdata.inst) this.filterIns();
      //   else this.loading = false
      // }
      // this.siteList = this.dialogdata.siteList
      this.getAssetallocationList()


      /**=====================client list============================================= */

      if (this.dialogdata.asset && this.dialogdata.clients) {
        this.clients = this.dialogdata.clients;
        console.log("this.clients", this.clients);
        this.dialogdata.clients.forEach((client) => {
          client.doHave = false
          // client.checked = false;
        })
        this.copyClients = this.clients
        if (this.dialogdata.client) this.filterClient();
        else this.loading = false

      }

    } else {
      if (this.dialogdata.inst) {
        this.alreadySharedInstructor = this.dialogdata.inst;
        if (this.alreadySharedInstructor.length > 0) {
          this.isPresent = true

          // this.filterIns()
        }
        else this.isPresent = false
        this.alreadySharedClient = this.dialogdata.client;
        if (this.alreadySharedClient.length > 0) {
          this.isPresentClient = true
          // this.filterIns()
        }
        else this.isPresentClient = false
      }
      console.log('Already Exists::::', this.alreadySharedClient, this.alreadySharedInstructor)
      console.log("this.isPresent", this.isPresent, "this.isPresentClient", this.isPresentClient);
      this.getInstructors();
      this.getClients();
    }


  }

  onInstructorChange(event) {
    console.log(event);
    if (event.checked == true) {
      this.selectedInstructors.push(event.source.value)
    }
    else if (event.checked == false) {
      this.selectedInstructors.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.selectedInstructors.splice(learner, 1)
        }
      })
    }
    console.log("this.selectedInstructors", this.selectedInstructors);
  }

  onSiteChange(event) {
    console.log(event);
    if (event.checked == true) {
      this.selectedSites.push(event.source.value)
    }
    else if (event.checked == false) {
      this.selectedSites.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.selectedSites.splice(learner, 1)
        }
      })
    }
    console.log("this.selectedSites", this.selectedSites);
  }


  onJobChange(event) {
    console.log(event.source.value);
    if (event.checked == true) {
      this.selectedJobs.push(event.source.value)
    }
    else if (event.checked == false) {
      this.selectedJobs.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.selectedJobs.splice(learner, 1)
        }
      })
    }
    console.log("this.selectedSites", this.selectedJobs);
  }

  onClientChange(event) {
    console.log(event);
    if (event.checked == true) {
      this.selectedClients.push(event.source.value)
    }
    else if (event.checked == false) {
      this.selectedClients.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.selectedClients.splice(learner, 1)
        }
      })
    }
    console.log("this.selectedClients", this.selectedClients);
  }



  allocateAsset() {
    console.log("selected inst", this.selectedInstructors);
    this.dialogRef.close({ instructors: this.selectedInstructors, sites: this.selectedSites, jobs: this.selectedJobs })
  }

  share() {
    this.buttonLoader = true;
    console.log("SELECTED INSTRUCTORS", this.selectedInstructors);
    console.log("SELECTED Clients", this.selectedClients);
    console.log('dialogdata:::::::::::', this.dialogdata);

    if (this.dialogdata.action) {
      console.log("DIALOGDATA HAS ACTION HENCE EMIT EVENT")
      this.dialogRef.close({ clients: this.selectedClients, instructors: this.selectedInstructors })
      this.buttonLoader = false;
    }
    else {
      let selectedInstructors = [];
      let selectedClients = [];
      let alreadySharedInstructor = [];
      let alreadySharedClient = [];
      let details;

      let filteredSelectedInstructors = [];
      let filteredSelectedClients = [];

      // if (this.selectedInstructors.length) {

      //   this.selectedInstructors.forEach((instructor) => {
      //     let newIns = { _id: instructor._id, name: instructor.name, email: instructor.email }
      //     selectedInstructors.push(newIns);
      //   });
      // }

      // if (this.selectedClients) {
      //   this.selectedClients.forEach((client) => {
      //     let newClient = { _id: client._id, name: client.name, email: client.email }
      //     selectedClients.push(newClient);
      //   });
      // }

      if (this.alreadySharedInstructor.length) {

        this.alreadySharedInstructor.forEach((ins) => {
          if (ins._id && ins._id != null) {
            let newIns = { _id: ins._id._id, name: ins._id.name }
            alreadySharedInstructor.push(newIns);
          }
        });
      }

      if (this.alreadySharedClient.length) {
        this.alreadySharedClient.forEach((ins) => {
          let newClie = { _id: ins._id, name: ins.name }
          alreadySharedClient.push(newClie);
        });
      }

      if (this.dialogdata && this.dialogdata.data.type == "folder") {
        details = {
          _id: this.dialogdata.data._id,
          title: this.dialogdata.data.title,
        }
      } else {
        details = {
          _id: this.dialogdata.data._id,
          title: this.dialogdata.data.title,
          path: this.dialogdata.data.path
        }
      }

      if (this.alreadySharedClient.length) {
        selectedClients = this.selectedClients.filter(o => !this.alreadySharedClient.find(o2 => o._id === o2._id._id))
      } else {
        selectedClients = this.selectedClients;
      }


      if (this.alreadySharedInstructor.length) {

        console.log('Inside If alreadySharedInstructor', this.alreadySharedInstructor, this.selectedInstructors);
        selectedInstructors = this.selectedInstructors.filter(o =>
          !this.alreadySharedInstructor.find(
            function (o2) {
              if (o2._id) {
                console.log("o2._id", o2._id)
                return o._id === o2._id._id
              }
            }
          ))
      } else {
        selectedInstructors = this.selectedInstructors;
      }
      console.log("what is the selected data=============", selectedInstructors);

      if (selectedInstructors.length) {

        selectedInstructors.forEach((instructor) => {
          let newIns = { _id: instructor._id, name: instructor.name, email: instructor.email }
          filteredSelectedInstructors.push(newIns);
        });
      }

      if (selectedClients.length) {
        selectedClients.forEach((client) => {
          let newClient = { _id: client._id, name: client.name, email: client.email }
          filteredSelectedClients.push(newClient);
        });
      }



      let selectedUsers = {
        selectedInstructors: filteredSelectedInstructors,
        selectedClients: filteredSelectedClients,
        alreadySharedInstructor: alreadySharedInstructor,
        alreadySharedClient: alreadySharedClient,
        file: details
      };




      console.log('Selected User Final Object:', selectedUsers);


      console.log("this.dialogdata.type", this.dialogdata.data.type);

      if (this.dialogdata.data.type == "folder") {
        console.log("selectedUsers", selectedUsers);
        this._folderService.shareFolder(selectedUsers).subscribe(res => {
          console.log("shareFolder response", res);

          this.dialogRef.close(selectedUsers)
          this.buttonLoader = false;
        })
      }
      else {
        console.log("selectedUsers", selectedUsers);
        this._folderService.shareFile(selectedUsers).subscribe(res => {
          console.log("shareFile response", res);
          this.dialogRef.close(selectedUsers)
          this.buttonLoader = false;
        })
      }
      this.dialogRef.close(selectedUsers)
    }
  }

  filterIns() {
    let data = []
    data = this.dialogdata.sharedInstructor;
    if (this.isPresent) { data = this.dialogdata.inst }
    console.log("filterIns called", this.instructors, data, this.dialogdata)
    if (this.instructors.length > 0 && (data && data.length > 0)) {
      this.instructors.forEach((e1) =>
        data.forEach((e2) => {
          console.log("WHAT IS IN THE E1", e1)
          console.log("THIS IS THE CONFIRM ARRAY", e2)
          if (e1 && e1._id && e2 && e2._id) {
            // console.log('e1._id', e1._id, "e2._id", e2._id._id)
            if (e1._id === e2._id._id) {
              this.selectedInstructors.push(e1);
              e1.checked = true;
              e1.doHave = true;
              // console.log("this.selectedInstructors in filterIns", this.selectedInstructors);
            }
          }
        }));
    }
    this.loading = false;
  }


  filterSites() {
    let data = []
    data = this.dialogdata.sharedSiteList;
    // if (this.isPresent) { data = this.dialogdata.inst }
    // console.log("filterIns called")
    if (this.instructors.length > 0) {
      this.siteList.forEach((e1) => data.forEach((e2) => {
        // if (e1 && e1._id && e2 && e2._id && e2._id._id) {
        // console.log('e1._id', e1._id, "e2._id", e2._id._id)
        if (e1._id == e2._id) {
          this.selectedSites.push(e1);
          e1.checked = true;
          e1.doHave = true;
          // console.log("this.selectedInstructors in filterIns", this.selectedInstructors);
        }
        // }
      }));
    }
    this.loading = false;
  }

  filterlinkedJob() {
    console.log("WHAT IS IN THE DIALOG DATA", this.dialogdata)
    let data = []
    data = this.dialogdata.sharedJobList;
    this.jobList.forEach((e1) => data.forEach((e2) => {
      if (e1._id == e2._id) {
        this.selectedJobs.push(e1);
        e1.checked = true;
        e1.doHave = true;
      }
    }));
    // }
  }

  filterClient() {
    let data = []
    if (this.isPresentClient) { data = this.dialogdata.client }
    else data = this.dialogdata.data.sharedClient;
    if (this.clients.length > 0) {
      console.log("IN if this.clients", this.clients, "data", data)
      this.clients.forEach((e1) => data.forEach((e2) => {
        if (e1 && e1._id && e2 && e2._id && e2._id._id) {
          if (e1._id == e2._id._id) {
            this.selectedClients.push(e1);
            e1.checked = true;
            e1.doHave = true;
          }
        }
      }));
      this.loading = false;
    }
  }

  filter(searchText) {

    if (this.dialogdata && this.dialogdata.asset) {
      console.log("THIS IS FOR ASSET");
      this.afterFilter = null
      if (searchText === '') {
        // this.clients = this.copyClients;
        this.instructors = this.copyInstructors
        this.siteList = this.siteListCopy
        this.jobList = this.jobListCopy
      } else {
        let data = []
        data = data.concat(this.instructors)
        data = data.concat(this.siteList)
        data = data.concat(this.jobList)

        console.log("THIS IS THE FIANL DATA TO BE SEND", data);
        let tempInst = this._filter.filter1(searchText, data, ['name', 'title', 'sentinelNumber']);
        console.log("AFTER SEARCH RESULT", tempInst);
        this.instructors = []
        this.siteList = []
        this.jobList = []
        const tempLength = tempInst.length
        for (let i = 0; i < tempLength; i++) {
          if (tempInst[i].type == 'staff') this.instructors.push(tempInst[i])
          else if (tempInst[i].type == 'site') this.siteList.push(tempInst[i])
          else this.jobList.push(tempInst[i])
        }
      }
    } else {
      this.afterFilter = null
      if (searchText === '') {
        this.clients = this.copyClients;
        this.instructors = this.copyInstructors
      }
      else {
        let tempInst = this._filter.staffFilterService(searchText, this.copyInstructors, ['name', 'sentinelNumber']);
        this.instructors = tempInst
        console.log("what is the client list", tempInst);
        let tempClient
        if (this.copyClients != undefined) {
          tempClient = this._filter.filter(searchText, this.copyClients, ['name'])
          this.clients = tempClient
          if (tempInst.length <= 0 && tempClient.length <= 0) {
            this.afterFilter = "No user with matched search text found"
          }
        } else {

          if (tempInst.length <= 0) {
            this.afterFilter = "No user with matched search text found"
          }
        }

      }
    }
  }

  // API CALLS
  getInstructors() {
    this.loading = true;
    // this._staffService.getInstructors().subscribe(instructors => {
    //   instructors.forEach((ins) => {
    //     // ins.checked = false;
    //     ins.doHave = false;
    //   })
    this._staffService.getAllStaff().subscribe(res => {
      let instructors = res.data.instructors
      instructors.forEach((ins) => {
        // ins.checked = false;
        ins.doHave = false;
      })
      this.instructors = instructors;
      this.copyInstructors = this.instructors;
      if (this.dialogdata.inst) this.filterIns();
      else this.loading = false
    });
  }

  getClients() {
    this.loading = true;
    this._clientService.getClients().subscribe(clients => {
      this.clients = clients;
      console.log("this.clients", this.clients);
      clients.forEach((client) => {
        client.doHave = false
        // client.checked = false;
      })
      this.copyClients = this.clients
      if (this.dialogdata.client) this.filterClient();
      else this.loading = false
    })

  }


  getAssetallocationList() {
    let obj = {
      locationType: 'asset'
    }
    this._assetService.getAssetallocationList(JSON.stringify(obj)).subscribe((list) => {
      console.log("THIS IS THE LIST OF ASSET ALLOCATION", list);
      this.assetallocationList = list
      this.instructors = list.staff
      this.siteList = list.sites
      this.jobList = list.jobs
      this.jobListCopy = list.jobs
      this.siteListCopy = list.sites
      this.copyInstructors = list.staff
      // this.instructors = this.dialogdata.instructors;
      this.copyInstructors = this.instructors;
      if (this.dialogdata.sharedInstructor) this.filterIns();
      if (this.dialogdata.sharedSiteList) this.filterSites()
      if (this.dialogdata.sharedJobList) this.filterlinkedJob()
    })
  }

  checkSelection(event) {
    console.log('Check Selection:', event);
    if (event.checked == true) {
      this.instructors.forEach(instructor => {
        instructor.checked = true;
        let index = _.findIndex(this.selectedInstructors, function (o) { return o._id == instructor._id })
        if (index == -1) {
          this.selectedInstructors.push(instructor);
        }
      })
    }
    else {

      console.log('alreadySharedInstructor==>', this.alreadySharedInstructor);
      this.instructors.forEach(instructor => {

        this.selectedInstructors = [];

        let index = _.findIndex(this.alreadySharedInstructor, function (o) { return o._id._id == instructor._id })

        if (index == -1) {
          instructor.checked = false;
        }

      })
    }
  }


  checkSites(event) {
    if (event.checked == true) {
      this.siteList.forEach(site => {
        site.checked = true;
        let index = _.findIndex(this.selectedSites, function (o) { return o._id == site._id })
        if (index == -1) {
          this.selectedSites.push(site);
        }
      })
    }
    else {

      console.log('alreadySharedInstructor==>', this.alreadySharedSites);
      this.siteList.forEach(site => {

        this.selectedSites = [];

        let index = _.findIndex(this.alreadySharedSites, function (o) { return o._id._id == site._id })

        if (index == -1) {
          site.checked = false;
        }

      })
    }
  }


  checkJobs(event) {
    if (event.checked == true) {
      this.jobList.forEach(site => {
        site.checked = true;
        let index = _.findIndex(this.selectedJobs, function (o) { return o._id == site._id })
        if (index == -1) {
          this.selectedJobs.push(site);
        }
      })
    }
    else {

      console.log('alreadySharedInstructor==>', this.alreadySharedSites);
      this.jobList.forEach(site => {

        this.selectedJobs = [];

        // let index = _.findIndex(this.alreadySharedSites, function (o) { return o._id._id == site._id })

        // if (index == -1) {
        site.checked = false;
        // }

      })
    }
  }

  checkSelectionClient(event) {
    console.log('Check Selection:', event);
    if (event.checked == true) {
      this.clients.forEach(client => {
        client.checked = true;
        let index = _.findIndex(this.selectedClients, function (o) { return o._id == client._id })
        if (index == -1) {
          this.selectedClients.push(client);
        }
      })
    }
    else {
      this.clients.forEach(client => {

        let index = _.findIndex(this.alreadySharedClient, function (o) { return o._id._id == client._id })

        if (index == -1) {
          client.checked = false;
        }

        this.selectedClients = [];
      })
    }
  }
}
